export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'sidebar_collapsed';
export const APP_ELEMENT_ID = 'app-root';
